import { Pipe, PipeTransform } from '@angular/core';
import { Statics } from '../statics/statics';

@Pipe({
  name: 'list',
  standalone: false,
})
export class ListPipe implements PipeTransform {
  transform(
    list: string[],
    options?: {
      lowercase?: 'all' | 'allButFirst';
      type?: 'conjunction' | 'disjunction';
    },
  ): string {
    return Statics[
      options?.type === 'disjunction'
        ? 'LIST_FORMATTER_DISJUNCTION'
        : 'LIST_FORMATTER_CONJUCTION'
    ].format(
      list.map((item, i) =>
        options?.lowercase === 'all' ||
        (options?.lowercase === 'allButFirst' && i !== 0)
          ? item.trim().toLowerCase()
          : item.trim(),
      ),
    );
  }
}
